"use client";

import Link from "next/link";
import { Action } from "@clover-web-lib-sprout/action";
import PageNotFoundImage from "../_icons/pageNotFound";

export default function PageNotFound() {
  return (
    <div className="w-full flex flex-col items-center justify-center h-[60vh]">
      <PageNotFoundImage />
      <h2 className="text-[32px] leading-[40px] mt-[22px] mb-[22px]">Page not found</h2>
      <p className="mb-[35px]">Sorry, but we couldn’t find that page</p>
    </div>
  );
}
